import React, { createContext, useContext, useReducer } from 'react';
import _ from 'lodash';

const selectionReducer = (state, action) => {
  const selectId = (selectedIds, id) => ({
    ...selectedIds,
    [id]: true,
  });

  const deselectId = (selectedIds, id) => _.omit(selectedIds, id);
  const toggleId = (selectedIds, id) => selectedIds[id] ? deselectId(selectedIds, id) : selectId(selectedIds, id);

  const individualSelection = (selectedIds) => ({
    selectedIds,
    hasSelection: !_.isEmpty(selectedIds),
    selectedCount: Object.keys(selectedIds).length,
  });

  switch (action.type) {
  case 'toggle':
    return {
      ...state,
      allSelected: false,
      ...individualSelection(toggleId(state.selectedIds, action.id)),
    };
  case 'select-all':
    return {
      ...state,
      allSelected: true,
      selectedIds: {},
      hasSelection: true,
      selectedCount: null,
    };
  case 'select-none':
    return {
      ...state,
      allSelected: false,
      selectedIds: {},
      hasSelection: false,
      selectedCount: null,
    };
  case 'set-selected-ids':
    return {
      ...state,
      allSelected: false,
      ...individualSelection(_.chain(action.selectedIds).keyBy().mapValues(() => true).value()),
    };
  }
  return state;
};

export const initialSelectionState = {
  allSelected: false,
  selectedIds: {},
  hasSelection: false,
  selectedCount: null,
};

export const SelectionContext = createContext();
export const SelectionContextProvider = ({ children }) => (
  <SelectionContext.Provider value={useReducer(selectionReducer, initialSelectionState)}>
    {children}
  </SelectionContext.Provider>
);

export const useSelectionContext = () => useContext(SelectionContext);
export function toggleId(id) {
  return {
    type: 'toggle',
    id,
  };
}
export function selectAll() {
  return {
    type: 'select-all',
  };
}

export function selectNone() {
  return {
    type: 'select-none',

  };
}

export function setSelection(selectedIds) {
  return {
    type: 'set-selected-ids',
    selectedIds,
  };
}
